import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PharmacyDetailsStepsEnum} from '../../../dashboard/interfaces/PharmacyDetailsStepsEnum';
import {PharmacyLocationEnum} from './PharmacyLocationEnum';
import {Select, Store} from '@ngxs/store';
import {PharmacyState} from '../../states/pharmacy/pharmacy.state';
import {Observable} from 'rxjs/internal/Observable';
import {take} from 'rxjs/operators';
import {SavePharmacyNPI, SavePharmacySelectedBaa} from '../../states/pharmacy/pharmacy.actions';
import { INpiStepData } from '../../interfaces/INpiStepData.interface';
import { ProfileState } from '../../states/profile/profile.state';

@Component({
  selector: 'app-pharmacy-details',
  templateUrl: './pharmacy-details.component.html',
  styleUrls: ['./pharmacy-details.component.scss'],
})
export class PharmacyDetailsComponent implements OnInit {
  @Input() location: PharmacyLocationEnum; // sign up or settings
  @Input() currentStep: PharmacyDetailsStepsEnum;

  @Output() stepChanged: EventEmitter<PharmacyDetailsStepsEnum> = new EventEmitter();
  @Output() submitted: EventEmitter<any> = new EventEmitter();
  @Output() closeForm: EventEmitter<void> = new EventEmitter();

  PharmacyDetailsStepsEnum = PharmacyDetailsStepsEnum;

  @Select(PharmacyState.pharmacyForm) pharmacyForm$: Observable<any>;

  constructor(private store: Store) {
  }

  ngOnInit(): void {
    this.pharmacyForm$.pipe(take(1))
      .subscribe((formData: any) => {
        if (formData) {
          this.currentStep = PharmacyDetailsStepsEnum.Details;
        }
      });
  }

  savePharmacy(formValue: any): void {
    this.submitted.emit(formValue);
  }

  nextStep(npiStepData: INpiStepData): void {
    this.store.dispatch(new SavePharmacyNPI(npiStepData.npi));
    this.store.dispatch(new SavePharmacySelectedBaa(npiStepData.baa));
    this.currentStep = PharmacyDetailsStepsEnum.Details;
    this.stepChanged.emit(this.currentStep);
  }

  cancelPharmacyForm(): void {
    this.currentStep = PharmacyDetailsStepsEnum.NpiNumber;
    this.stepChanged.emit(this.currentStep);
  }
}
